import { GetApp } from "@mui/icons-material";
import React from "react";
import { Link } from "react-router-dom";
import TextEffect from "../TextEffect";

const Home = () => {
  return (
    <div className="flex items-center home lg:min-h-[calc(100vh-120px)]">
      <div className="w-full grid grid-cols-1 lg:grid-cols-2 gap-[3rem] items-center">
        <div>
          <span className="eyebrow">Hi, I'm</span>
          <h1 className="text-[36px] sm:text-[44px] md:text-[52px] text-yellow-400 font-semibold leading-[1.05] tracking-[-0.03em]">
            Unique Adhikari
          </h1>
          <TextEffect />

          <p className="body-copy mt-[1.75rem] max-w-[60ch]">
            Hello! I'm currently pursuing a BSc. CSIT at Tribhuvan University,
            where I'm involved in the fields of data science, machine
            learning, and backend development. Hailing from Nepal, I'm
            passionate about building efficient backend architectures, building
            smart AI models, and extracting actionable insights.
          </p>
          <p className="body-copy mt-[1rem] max-w-[60ch]">
            Explore my portfolio to see my projects and discover what I can
            bring to the tech community.
          </p>

          <div className="mt-[2.25rem] grid grid-cols-2 sm:flex sm:flex-wrap items-center gap-3">
            <a
              href="/Personal_CV.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="no-underline h-[44px] px-[1.25rem] hover:bg-yellow-400 transition-colors duration-150 text-[14px] font-semibold bg-[#55e6a5] text-[#121121] hover:text-[#121121] inline-flex gap-2 rounded-md items-center justify-center"
            >
              Download CV
              <GetApp fontSize="small" />
            </a>
            <Link
              to="/classroom"
              className="no-underline h-[44px] px-[1.25rem] border border-white/20 hover:border-[#55e6a5] hover:text-[#55e6a5] transition-colors duration-150 text-[14px] font-semibold text-white inline-flex rounded-md items-center justify-center"
            >
              Open classroom
            </Link>
          </div>
        </div>

        <div className="w-[300px] h-[300px] lg:w-[360px] lg:h-[360px] hidden lg:flex bg-[#55e6a5] overflow-hidden rounded-full mx-auto shadow-2xl">
          <img
            src={require("../../assets/images/rounded_profile.jpg")}
            alt="Unique Adhikari"
            className="w-full h-full object-cover"
          />
        </div>
      </div>
    </div>
  );
};

export default Home;
